import React from 'react';
import PropTypes from 'prop-types';

import AppLink from 'components/App/AppLink';

import { CURRENCY_LABEL, LOCATIONS } from 'constants/index';
import { convertIsoDateToString } from 'utils';
import { currencyFormat } from 'utils/currencyFormat';

import styles from './FananceDataTableInvoiceDetail.module.scss';

function FananceDataTableInvoiceDetail({ bookings }) {
  return (
    <div className={styles.Component}>
      {bookings.length === 0 ? (
        <div className={styles.NoData}>Chưa có dữ liệu</div>
      ) : (
        <table className={styles.Table}>
          <thead>
            <tr>
              <th>Khách hàng</th>
              <th>Mã đặt phòng</th>
              <th>Ngày nhận phòng</th>
              <th>Ngày trả phòng</th>
              <th>Tổng số tiền</th>
            </tr>
          </thead>

          <tbody>
            {bookings.map((item) => (
              <tr key={item.booking || item.orderId}>
                <td>{item.user?.fullName || item.customerName || '-'}</td>

                <td>
                  <AppLink
                    href={LOCATIONS.MANAGER_BOOKING_DETAIL.replace(':id', item.booking)}
                    className={styles.BookingLink}
                  >
                    {`#${item.orderId}`}
                  </AppLink>
                </td>

                <td>{convertIsoDateToString(item.checkInDate)}</td>

                <td>{convertIsoDateToString(item.checkOutDate)}</td>

                <td>
                  <strong>
                    {currencyFormat({
                      currency: CURRENCY_LABEL,
                      value: item.amount || 0,
                    })}
                  </strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

FananceDataTableInvoiceDetail.propTypes = {
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      booking: PropTypes.string,
      orderId: PropTypes.string,
      customerName: PropTypes.string,
      user: PropTypes.shape({
        _id: PropTypes.string,
        fullName: PropTypes.string,
        level: PropTypes.string,
      }),
      checkInDate: PropTypes.string,
      checkOutDate: PropTypes.string,
      amount: PropTypes.number,
    }),
  ).isRequired,
};

export default React.memo(FananceDataTableInvoiceDetail);
